import { render, staticRenderFns } from "./Totals.vue?vue&type=template&id=4bf56d90&scoped=true&"
import script from "./Totals.vue?vue&type=script&lang=js&"
export * from "./Totals.vue?vue&type=script&lang=js&"
import style0 from "./Totals.vue?vue&type=style&index=0&id=4bf56d90&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf56d90",
  null
  
)

export default component.exports